import React, { useState, useEffect } from "react";

import { Link, Redirect } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useFirebase } from 'react-redux-firebase';

import Loading from "../components/Loading";

const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[[]]/g, "\\$&");
  let regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

const ResetPassword = () => {
  const {register, handleSubmit} = useForm();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [verifyTokenLoading, setVerifyTokenLoading] = useState(true);
  const [invalidToken, setInvalidToken] = useState(false);
  const firebase = useFirebase();
  const code = getParameterByName("oobCode", window.location.href);

  useEffect(() => {
    const handleResetPassword = async () => {
      try {
        await firebase.verifyPasswordResetCode(code);
      } catch (e) {
        setInvalidToken(true);
      } finally {
        setVerifyTokenLoading(false);
      }
    };

    firebase.logout();
    handleResetPassword();
  }, [code, firebase]);

  const reset = async ({password, passwordConfirmation}) => {
    if (password !== passwordConfirmation) {
      setError("Passwords don't match")
      return;
    }

    try {
      await firebase.confirmPasswordReset(code, password);
      setSuccess(true);
    } catch ({ message }) {
      setError(message);
    }
  }

  const Form = () => (
    <>
      <h1 className="h3 mb-3">Reset password</h1>
      <form className="text-left" onSubmit={handleSubmit(reset)}>
        <div className="form-group">
          <label>New password*</label>
          <input type="password" name="password" className="form-control" ref={register}/>
        </div>
        <div className="form-group mb-4">
          <label>Confirm new password*</label>
          <input type="password" name="passwordConfirmation" className="form-control" ref={register}/>
        </div>
       { error && (
          <p className="alert alert-warning text-center">
            {error}
          </p>
        )}
        <div className="form-group mb-0">
          <input type="submit" className="btn btn-primary btn-block" value="Continue" />
        </div>
      </form>
    </>
  )

  if (success) {
    return <Redirect to="/login" />
  }

  return (
    <div className="container">
      <a href="https://narratedbypoise.com" className="logo">Poise</a>
      <a href="https://narratedbypoise.com" className="back back-home">
        <i className="fas fa-long-arrow-alt-left"></i>
        &nbsp;
        Back home
      </a>
      <div className="row  justify-content-center text-center mt-5">
        <div className="col-md-12 col-lg-5 col-xl-5 mt-5">
          <div className="card screen reset">
            <div className="credentials">
              { verifyTokenLoading && (
                <Loading />
              )}
              { !verifyTokenLoading && invalidToken && (
                <p className="alert alert-warning text-center">
                 Password reset has expired <br /><Link to={"/forgot-password"}>Request a new link</Link>
                </p>
              )}
              { !verifyTokenLoading && !invalidToken && (
                <Form />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
